import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import EncryptStorage from 'encrypt-storage';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AuthService } from 'src/app/auth/auth.service';
import { Product, ProductSearch } from 'src/app/models/product';
import { emptyFields, UsersType } from 'src/app/utilities/common-file';
import { Messages } from 'src/app/utilities/message';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { ProductService } from '../../product.service';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
export const encryptStorage = EncryptStorage('secret_key', {
  storageType: 'localStorage'
});
@Component({
  selector: 'app-add-location-product-component',
  templateUrl: './add-location-product-component.component.html',
 })
export class AddLocationProductComponentComponent implements OnInit {

  fileList = [];
  loading = false; 
 merchantId:number;
 emptyField = emptyFields;
 userType = UsersType;
 selectedLocation:string;
 selectedProduct:any;
 documentImage: any;
 commentForm: UntypedFormGroup;
 loginUserType = '';
 isVisible=false;
 checked=true;
 documentImageName: any;
 previewVisible = false;
 previewImage: string | undefined = '';
 locationsList = [];
 productModal: NzModalRef;
 showUploadList = {
   showPreviewIcon: true,
   showRemoveIcon: true,
   hidePreviewIconInNonImage: true
 };
 selectedRow:any;
 merchantProductForm: UntypedFormGroup;
 @Input() buttonLoading = false;
 @Input() selectedMerchantProduct;
 @Input() buttonLoadingForUpdate = false;
 @Output() onSavedMerchantProduct = new EventEmitter<any>();
 @Output() onEditMerchantProduct = new EventEmitter<any>();
 showDownload:string ;
selectedRateDateRange: Date[] = null;
 private tableData: NzTableData<ProductSearch, any> = new NzTableData<ProductSearch, any>(new ProductSearch(), 'name');

 constructor(
   private fb: UntypedFormBuilder,
   private productService : ProductService,
   private notification: NzNotificationService,
   private modal: NzModalService,
   private authService: AuthService
   ) { 
   this.merchantProductForm = this.fb.group({
     merchantId: [''],
     name: ['', Validators.required],
     price: ['', Validators.required],
     description: ['', Validators.required],
     additionalNotes: ['',Validators.required],
     code: ['', Validators.required]
    });
    this.commentForm = this.fb.group({
     comments: [''],
     isAvailable: [],
   });
 }

 ngOnInit() {
    this.merchantId =+ encryptStorage.getItem('merchantId');
      this.loginUserType = this.authService.getRole();
     this.getLocations();
    this.refresh();
   }

 getLocations() {
   this.locationsList = this.authService.getLocationDetails();
     this.tableData.search.locationId = this.locationsList[0].id;
    this.selectedLocation = this.locationsList.find(x=>x.id === this.tableData.search.locationId).name;
 }
getProductImageList(productId,merchantId){
  const value={
   productId:productId,
   merchantId:merchantId,
   pageSize: 10,
   pageIndex:1
 }
  this.productService.getImageList(value).subscribe((res:any) => {
    let imageLists = res.data.merchantProductImages;
   this.fileList=[];
   for(let i=0;i<imageLists.length;i++){
   this.productService.getBlobImage(imageLists[i]).subscribe((res:any)=>{
     const file = new File([res], imageLists[i].imageName, { type: res.type });
     const images = {
       originFileObj: file,
       id:imageLists[i].id,
       isUpload:false
     };
     this.fileList = this.fileList.concat(images);
   });
   }
  }, error => {
    this.buttonLoading = false;
 });
}
// Preview Image
handlePreview = (file: NzUploadFile) => {
 this.previewImage = file.url || file.thumbUrl;
 this.previewVisible = true;
}
// API request for Save
saveProduct() {
if (this.merchantProductForm.valid) {
 // if (this.merchantProductForm.value.mId.trim() && this.merchantProductForm.value.code.trim() && this.merchantProductForm.value.name.trim()) {
   this.buttonLoading = true;
   this.merchantProductForm.value.merchantId=+this.merchantId;
   this.productService.createProduct(this.merchantProductForm.value).subscribe((res:any) => {
     this.notification.success(Messages.saved, '', {
       nzKey: 'key'
     });
     this.uploadFormData(res.data.id,this.fileList);
     this.onSavedMerchantProduct.emit(res as Product);
   }, error => {
     this.buttonLoading = false;
   });
} else {
 this.buttonLoading = false;
 // tslint:disable-next-line: forin
 for (const i in this.merchantProductForm.controls) {
   this.merchantProductForm.controls[i].markAsDirty();
   this.merchantProductForm.controls[i].updateValueAndValidity();
   this.notification.error(Messages.error, '', {
     nzKey: 'key'
   });
 }
}
}
 // Delete Image confirmation
 // removeFileImage = (file: UploadXHRArgs) => {
 //   this.modal.confirm({
 //     nzTitle: 'Are you sure you want to delete this image?',
 //     nzOkText: 'Yes',
 //     nzOkType: 'danger',
 //     nzOnOk: () => this.deleteProductImage(file),
 //     nzCancelText: 'No',
 //     nzOnCancel: () => console.log('Cancel')
 //   });
 // }
// // Delete Product
// deleteProductImage(file) {
//   this.notification.info('Processing', 'Please Wait', {
//     nzKey: 'key'
//   });
//          this.productService.deleteImage(file).subscribe((response: any) => {
//           this.notification.success(Messages.deleted, '', {
//             nzKey: 'key'
//           });
//           this.fileList = [];
//           this.getProductImageList(this.selectedMerchantProduct.id);
//          }, (err) => {
//         });
// }
// For Edit Product
editProduct() {
  if (this.merchantProductForm.valid) {
   this.buttonLoadingForUpdate = true;
    this.merchantProductForm.value.merchantId=this.merchantId;
   this.productService.editProduct(this.selectedMerchantProduct.id, this.merchantProductForm.value).subscribe((res) => {
     this.notification.success(Messages.updated, '', {
       nzKey: 'key'
     });
     if(this.fileList.length > 0){
      this.uploadFormData(this.selectedMerchantProduct.id,this.fileList);
     }
     this.onEditMerchantProduct.emit(res as Product); // Emits response to edit-banks component to close drawer
 }, () => {
    this.buttonLoadingForUpdate = false;
   });

} else {
  this.buttonLoadingForUpdate = false;
 // tslint:disable-next-line: forin
 for (const i in this.merchantProductForm.controls) {
   this.merchantProductForm.controls[i].markAsDirty();
   this.merchantProductForm.controls[i].updateValueAndValidity();
   this.notification.error(Messages.error, '', {
     nzKey: 'key'
   });
 }
}
}
locationChange(event){
let id =+ event;
this.selectedLocation = this.locationsList.find(x=>x.id === id).name;
}
 // Delete branch confirmation
 showDeleteConfirm() {
   this.modal.confirm({
    nzTitle: 'Are you sure you want to delete this Product?',
    nzOkText: 'Yes',
    nzOkType: 'danger',
    nzOnOk: () => this.deleteProduct(this.selectedMerchantProduct),
    nzCancelText: 'No',
    nzOnCancel: () => console.log('Cancel')
  });
}
// Delete Product
deleteProduct(value){
 this.productService.deleteProduct(value).subscribe((res:any) => {
  this.notification.success(Messages.deleted, '', {
    nzKey: 'key'
  });
  this.onEditMerchantProduct.emit(res as Product);
});
}
// For uploading image document
customReqForDocumentUpload = (item: NzUploadXHRArgs) => {
  this.documentImageName = item.file.name;
 {{ this.documentImageName}}
   const imageObj = {
     originFileObj: item.file,
     status: 'done',
     isUpload:true
   };   
    this.fileList = this.fileList.concat(imageObj);    
   item.onSuccess!('', item.file!, '');
}
uploadFormData(referenceId,images: any | null) {
  for(let i=0;i<images.length;i++){
    if(images[i].isUpload){
     let data = new FormData();
     data.append("referenceId",referenceId);
     data.append("file", images[i].originFileObj);
     data.append("imageKey", "productImages");
     this.productService.profileImageUpload(data).subscribe((res:any) => {

      },error => {
    });
    }
 }
}
showConfirmationForSelect(row){
  this.isVisible=true;
 this.selectedLocation = this.locationsList.find(x=>x.id === this.tableData.search.locationId).name;
 this.selectedRow = row;
}
// For List
refresh(startFromPageOne: boolean = true): void {
  this.loading = true;
 this.tableData.data = [];
 if (startFromPageOne) {
   this.tableData.pageIndex = 1;
 }
  this.tableData.search.linkedProduct=false;
   if(this.loginUserType !== 'merchant'){
    this.tableData.search.locationId = this.authService.getLocationId();
  }
  this.tableData.search.merchantId = this.merchantId.toString();
  this.productService.getLocationBasedProductList(this.tableData).subscribe((response: any) => {
    this.loading = false;
   this.tableData.total = response.data.total;
   this.tableData.data = response.data.productViews;
}, () => {
   this.loading = false;
});
}
handleCancel(): void {
 this.isVisible = false;
}
handleOk = (file: NzUploadXHRArgs) => {
 this.modal.confirm({
   nzTitle: 'Are you sure you want to add Product Name to Location Name?',
   nzOkText: 'Yes',
   nzOkType: 'danger',
   nzOnOk: () => this.addLocationToProduct(),
   nzCancelText: 'No',
   nzOnCancel: () => console.log('Cancel')
 });
}
addLocationToProduct(){
//    this.selectedRow;
//   const value ={
//     merchantId:this.selectedRow.merchantId,
//     productId:this.selectedRow.productId,
//     appCode:this.selectedRow.appCode,
//     locationId:this.selectedRow.locationId,
//     isAvailable:this.checked,
//     comments:''
//   }
//   this.productService.createMerchantLocationProduct(value).subscribe((response: any) => {
//     this.loading = false;
//    this.tableData.total = response.data.total;
//    this.tableData.data = response.data.merchantProduct;
// }, () => {
//   this.loading = false;
// });
}
// Merchant Product Assign Location popup confirmation
merchantProductAssignLocationConfirm(
 row,
 merchantProductAssignLocationModal: TemplateRef<{}>
) {
    this.selectedProduct = row;
     this.commentForm.reset();
     this.commentForm.controls.isAvailable.setValue(true);
   this.getProductImageList(row.id,row.merchantId);
 this.productModal = this.modal.create({
   nzContent: merchantProductAssignLocationModal,
   nzClosable: false,
   nzWidth:'640px',
   nzMaskClosable: false,
   nzOkText: 'Add Product',
   nzOnOk: () => this.assignLocation(row),
   nzCancelText: 'No',
   nzOnCancel: () => console.log('Cancel')
 });
}
 // Assign Location API
 assignLocation(data) {
     const args = {
     merchantId:this.merchantId,
     productId:data.id,
     isAvailable: this.commentForm.value.isAvailable,
     locationId:this.tableData.search.locationId,
     comments: this.commentForm.value.comments,
     appCode:data.merchant.appCode
   }
   this.productService.merchantProductAssignLocation(args).subscribe(
     (res) => { 
       this.refresh();
       this.notification.success(Messages.saved, '', {
         nzKey: 'key',
       });
     },
     (error) => { 
     });
 }
 // For Page Index change
onIndexChange(event) {
 this.tableData.pageIndex = event;
 this.refresh(false);
}
 // To clear search fields
 clearSearch(value) {
   return this.productService.clearSearchFields(this.tableData, value);
 }
}

